import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme, useTheme } from "@material-ui/core/styles";
import clsx from "clsx";
import { featureTileYellow } from "theme";
import PaginationButton from "components/pagination/PaginationButton";

const useStyles = makeStyles((theme: Theme) => {
    const defaultCircleSize = theme.spacing(1.5);
    const selectedCircleSize = theme.spacing(1.8);
    const circleSizeDiff = selectedCircleSize - defaultCircleSize;

    const defaultCircleMargin = theme.spacing(0.5);
    const selectedCircleMargin = defaultCircleMargin - circleSizeDiff;

    return createStyles({
        root: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
        },
        paginationCircle: {
            height: defaultCircleSize,
            width: defaultCircleSize,
            borderRadius: defaultCircleSize / 2,
            cursor: "pointer",
            backgroundColor: theme.palette.common.white,
            margin: defaultCircleMargin,
            "&:hover": {
                backgroundColor: featureTileYellow,
            },
        },
        selectedCircle: {
            cursor: "default",
            height: selectedCircleSize,
            width: selectedCircleSize,
            borderRadius: selectedCircleSize / 2,
            backgroundColor: featureTileYellow,
            margin: selectedCircleMargin,
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {
    numberOfItems: number;
    onPaginationClick: (itemIndex: number) => void;
    currentlySelectedItemIndex: number;
    disableArrows?: boolean;
}

export default function SelectableCollectionPagination(props: IProps) {
    const classes = useStyles();
    const {
        numberOfItems,
        onPaginationClick,
        currentlySelectedItemIndex,
        disableArrows = false,
        className,
        ...rest
    } = props;

    const theme = useTheme();
    const buttonSpacing = theme.spacing(1);

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            {disableArrows ? null : (
                <div style={{ marginRight: buttonSpacing }}>
                    <PaginationButton
                        variant="previous"
                        disabled={currentlySelectedItemIndex === 0}
                        onClick={() => onPaginationClick(currentlySelectedItemIndex - 1)}
                    />
                </div>
            )}
            {Array.from(Array(numberOfItems)).map((_, i) => {
                return (
                    <div
                        className={clsx(classes.paginationCircle, {
                            [classes.selectedCircle]: i === currentlySelectedItemIndex,
                        })}
                        onClick={() => onPaginationClick(i)}
                    />
                );
            })}
            {disableArrows ? null : (
                <div style={{ marginLeft: buttonSpacing }}>
                    <PaginationButton
                        variant="next"
                        disabled={currentlySelectedItemIndex === numberOfItems - 1}
                        onClick={() => onPaginationClick(currentlySelectedItemIndex + 1)}
                    />
                </div>
            )}
        </div>
    );
}
